/**
 * Service fee + VAT on top of a price — mirrors server/utils/pricing.js
 * (the server's number is what's charged; this is for the price summaries).
 *
 *   net = subtotal − discount · fee = net × fee% · vat = (net + fee) × vat%
 */
export interface PricingRates {
  serviceFeePercent: number;
  vatPercent: number;
}

export interface Charges {
  subtotal: number;
  discountAmount: number;
  serviceFee: number;
  vatAmount: number;
  totalPrice: number;
}

const round2 = (n: number) => Math.round((Number(n) || 0) * 100) / 100;

export function computeCharges(subtotal: number, discountAmount = 0, rates?: PricingRates | null): Charges {
  const sub = round2(subtotal);
  const discount = round2(Math.min(Math.max(0, discountAmount), sub));
  const net = round2(sub - discount);
  const serviceFee = round2((net * (rates?.serviceFeePercent ?? 0)) / 100);
  const vatAmount = round2(((net + serviceFee) * (rates?.vatPercent ?? 0)) / 100);
  return { subtotal: sub, discountAmount: discount, serviceFee, vatAmount, totalPrice: round2(net + serviceFee + vatAmount) };
}

/** 1234.5 → "1,234.5" (no trailing zeros for whole numbers). */
export const fmtMoney = (n: number) => (Number(n) || 0).toLocaleString("en-US", { maximumFractionDigits: 2 });
